import { Box, Typography } from '@mui/material';
import { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as VisaIcon } from 'src/assets/svg/visa1.svg';
import { ReactComponent as MastercardIcon } from 'src/assets/svg/mastercard.svg';
import { ReactComponent as GroupIcon } from 'src/assets/svg/group.svg';
import { ReactComponent as JvcIcon } from 'src/assets/svg/jcb.svg';
import { ReactComponent as UpiIcon } from 'src/assets/svg/upi.svg';
import { ReactComponent as DiscoverIcon } from 'src/assets/svg/discover.svg';

import { styles } from './styles';

export const PaymentOptionBanner: FC<{
    showPaymentOptions?: boolean;
    showSantanderCards?: boolean;
}> = ({ showPaymentOptions = false, showSantanderCards = false }) => {
    const { t } = useTranslation();

    const containerStyle = showSantanderCards ? styles.containerSantander : styles.container;
    const acceptedCardStyles = showSantanderCards
        ? styles.paymentIconsWithSideTextSantander
        : styles.paymentIconsWithSideText;

    const wrapperStyles = showSantanderCards ? styles.iconsWrapperSantander : styles.iconsWrapper;
    const paymentIconStyles = showPaymentOptions ? acceptedCardStyles : wrapperStyles;

    return (
        <Box css={containerStyle}>
            {showPaymentOptions && (
                <Typography variant="body4" css={styles.optionText}>
                    {t('payment_option_info')}
                </Typography>
            )}
            <Box css={paymentIconStyles}>
                <VisaIcon css={styles.icon1} />
                <MastercardIcon css={styles.icon2} />
                <GroupIcon css={styles.icon3} />
                {showSantanderCards && (
                    <Fragment>
                        <JvcIcon css={styles.icon1} />
                        <UpiIcon css={styles.icon2} />
                        <DiscoverIcon css={styles.icon3} />
                    </Fragment>
                )}
            </Box>
        </Box>
    );
};
